import { useEffect, useState } from "react";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import DataTable from "../../component/DataTable";
import AdminHeader from "../../component/AdminHeader";
import ApplicationStatusModal from "./ApplicationStatusModal";

const jobApplicationsListEndpoint = ApiEndpoints.jobApplication.List;

const tableHeader = ["Date", "Name", "last name", "phone", "email", "company Name", "Higher Education", "Vacancy", "Current Salary/M", "Notice Period", "Current Designation", "Current Location", "From Date", "To Date", "Currently Working", "Total Experience", "Current CTC", "education", "Institute Name", "degree", "Specialization", "Institute Location", "education description", "From Date", "To Date", "persuing course", "linkedin profile", "cover note", "resume", "message", "comment",  "Status"];
const tbody = ["createdAt", "first_name", "last_name", "phone", "email", "experience_company", "education_degree", "vacancy", "monthly_current_salary", "notice_period_in_days", "experience_designation", "experience_location", "experience_from", "experience_to", "experience_currently_working", "total_work_exp_in_year", "current_ctc_in_lakh", "education_are_you", "education_institutions", "education_degree", "education_specialization", "education_location", "education_description", "education_from", "education_to", "education_persuing_course", "linkedin", "cover_note", "resume", "message",  "comment",   "application_status"];

export default function JobApplications() {
  const [data, setData] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  // const dataFetch = async () => {
  //   try {
  //     const response = await ApiRequest("GET", jobApplicationsListEndpoint);
  //     const result = response.jobs;
  //     setData(result);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // useEffect(() => {
  //   dataFetch();
  // }, []);


   const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", jobApplicationsListEndpoint);
      const result = response.jobs || [];

      // Preserve local updates
      setData(prev => {
        return result.map(item => {
          const localItem = prev.find(d => d._id === item._id);
          if (localItem) {
            return {
              ...item,
              application_status: localItem.application_status ?? item.application_status,
              comment: localItem.comment ?? item.comment,
            };
          }
          return item;
        });
      });
    } catch (error) {
      console.log("Error fetching job applications:", error);
    }
  };

  useEffect(() => {
    dataFetch();
  }, []);


  const pagename = {
    name: 'Job Applications',
    user: 'Admin',
    innerpage: 'Job Applications'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />

      <div className="add-btn-section contact-manage-tab">
         <DataTable
          data={data}
          setData={setData}
          tableHeader={tableHeader}
          tbody={tbody}
          showAction={true}
          setModalShow={setModalShow}
          setId={setSelectedId}
        />
      
      </div>

   <ApplicationStatusModal
        show={modalShow}
        applicationId={selectedId}
        onClose={() => setModalShow(false)}
        data={data}
        setData={setData}
      />
    </>
  )
}
